import 'mdn-polyfills/NodeList.prototype.forEach';
import Simulator from './Simulator';

document.addEventListener('DOMContentLoaded', () => {
  const simulatorButtons = document.querySelectorAll('fin-microsimu');
  if (!simulatorButtons.length) {
    return;
  }

  simulatorButtons.forEach((element) => {
    const simulatorButton = new Simulator(element);
    simulatorButton.mount(element);
  });
});
